import { CohabitationDetailForm } from 'cohabitation/view-models/detail-cohabitation';
import { DateTime } from 'luxon';
import { GivenHeaderData } from 'shell/models/person';
import { FamilyCoexistence } from 'shell/models/person/family';

interface RequestCancellationCohabition {
  estremiSchedaConvivenza?: FamilyCoexistence;
  testataRichiesta?: GivenHeaderData;
  datiArchiviazione: {
    dataDecorrenzaArchiviazione: string;
  };
}

export const transformerRequestCancellationCohabitation = (
  values: CohabitationDetailForm
): RequestCancellationCohabition => {
  const estremiSchedaConvivenza = {
    dataOrigineFamigliaConvivenza:
      values?.accordionCohabitation?.originDate?.toFormat('yyyy-MM-dd'),
    denominazioneConvivenza: values?.accordionCohabitation?.nameCohabitation,
    idFamigliaConvivenzaANPR: values?.accordionCohabitation?.idANPR,
    idFamigliaConvivenzaComune:
      values?.accordionCohabitation?.municipalityIdentifier ||
      values?.accordionCohabitation?.istatCode
        ? {
            idFamigliaConvivenza: values?.accordionCohabitation?.municipalityIdentifier,
            idFamigliaConvivenzaComuneIstat: values?.accordionCohabitation?.istatCode,
          }
        : undefined,
    tipoScheda: values?.accordionCohabitation?.tipoScheda,
    tipoMovimentazione: values?.accordionCohabitation?.tipoMovimentazione,
    presenzaFamigliaCoabitante: values?.accordionCohabitation?.presenzaFamigliaCoabitante,
    specieConvivenza: values?.accordionCohabitation?.kindCohabitation,
    motivoCostituzione: values?.accordionCohabitation?.motivoCostituzione,
    famigliaAire: values?.accordionCohabitation?.famigliaAire,
  };

  return {
    estremiSchedaConvivenza,
    testataRichiesta: {
      dataDecorrenza:
        values?.editDataControl?.dateValidity?.toFormat('yyyy-MM-dd') ||
        DateTime.now().toFormat('yyyy-MM-dd'),
    },
    datiArchiviazione: {
      dataDecorrenzaArchiviazione: DateTime.now().toFormat('yyyy-MM-dd'),
    },
  };
};
